<template>
  <div class="pay_list">
    <dl>
      <dt>订单编号：{{businessId}}</dt>
      <dd>
        <img :src="params.coverUrl" class="list_img" />
        <h3>{{params.title}}</h3>
        <p class="price_a">金额 ¥<span>{{params.price}}</span>元</p>
      </dd>
    </dl>
  </div>
</template>
<script>
  export default {
    name: 'planPayInfo',
    props: ['businessID', 'productID'],
    data () {
      return {
        productId: this.productID,
        businessId: this.businessID,
        params: {},
        result: {}
      }
    },
    created () {
      this.getModel(this.productId)
    },
    methods: {
      getModel (id) {
        this.$api.get(this.$global.planApiPath, '/trainingplans/' + id, null, r => {
          if (r.data) {
            this.params = r.data
            this.result = {
              money: this.params.price,
              subject: this.params.title
            }
            this.$emit('success', this.result)
          }
        })
      }
    }
  }
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/page/modules/plan/pay_info.vue